import React, { useRef, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
// import { menuItems } from "./menuItemsValues";
import MenuItems from "./MenuItems";
import "../Styles/main.css";
import { useTranslation } from "react-i18next";
import "../Translation/i18n";
import i18n from "i18next";

function NavBar() {
  const { t } = useTranslation();

  const menuItems = [
    {
      title: t("menu_title_home"),
      target: "/",
    },
    {
      title: t("menu_title_who_we_are"),
      submenu: [
        {
          title: t("menu_title_about_us"),
          target: "/about-us",
        },
        {
          title: t("menu_title_vision"),
          target: "/our-vision",
        },
        {
          title: t("menu_title_members"),
          target: "/board-members",
        },
        {
          title: t("menu_title_partners"),
          target: "/partner-in-success",
        },
        // {
        //   title: t("menu_title_shareholders"),
        //   target: "/shareholders",
        // },
      ],
    },
    {
      title: t("menu_title_issues"),
      target: "/issues",
    },
    {
      title: t("menu_title_coupons"),
      target: "/coupons",
    },

    {
      title: t("menu_title_contact_us"),
      target: "/contact-us",
    },
  ];

  const navRef = useRef();

  const showNabar = () => {
    navRef.current.classList.toggle("responsive_nav");
  };

  const [directionState, setDirectionState] = useState("ltr");

  React.useEffect(() => {
    if (i18n.language.includes("en")) {
      setDirectionState("ltr");
    } else {
      setDirectionState("rtl");
    }
    console.log("i18n.locale: " + i18n.language);
  });

  return (
    <header
      style={{
        backgroundColor: "#ffffff",
      }}
    >
      <img
        href="/"
        src={require("../assets/main_logo.png")}
        height={40}
        // width={100}
        alt="logo"
        style={{ marginLeft: 10, marginTop: 40, marginBottom: 40 }}
      />

      <nav ref={navRef} dir={directionState}>
        <ul
          className="menus"
          style={{ marginLeft: -100, marginTop: 40, marginBottom: 40 }}
        >
          {menuItems.map((menu, index) => {
            const depthLevel = 0;
            return (
              <MenuItems items={menu} key={index} depthLevel={depthLevel} />
            );
          })}
        </ul>
      </nav>
      <button className="nav-btn nav-close-btn" onClick={showNabar}>
        <FaBars />
      </button>
    </header>
  );
}

export default NavBar;
